import { ButtonBar } from "@gearbox-protocol/deploy-tools-ui";
import type { TaskDefinitionFormSchema } from "api";
import { FileContentView } from "components/file-upload";
import type { FC } from "react";
import { useLoaderData } from "react-router-dom";

import TaskDefinitionDropdownMenu from "../dropdown";
import TaskDefinitionView from "./TaskDefinitionView";
import useTaskDefinitionViewNav from "./useTaskDefinitionViewNav";

export const TaskDefinitionRoute: FC = () => {
  const definition = useLoaderData() as TaskDefinitionFormSchema;
  const { nav, tab, setTab, artifact } = useTaskDefinitionViewNav(definition);

  return (
    <div className="flex flex-col flex-1 rounded-xl bg-background p-4 gap-y-2">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col">
          <h2>{definition.id}</h2>
          {definition.description && (
            <p className="text-muted-foreground text-sm">
              {definition.description}
            </p>
          )}
        </div>

        <TaskDefinitionDropdownMenu definitionId={definition.id} />
      </div>

      {!!nav && (
        <ButtonBar
          items={nav}
          activeId={tab}
          onChange={setTab}
          buttonClassName="py-1! bg-white/10 hover:bg-black/10 has-checked:bg-black/20"
        />
      )}

      {artifact ? (
        <FileContentView file={artifact} className="w-full flex-1" />
      ) : (
        <TaskDefinitionView definition={definition} />
      )}
    </div>
  );
};
